(function () {
  'use strict';

  var slider = document.querySelector('[data-announcement-slider]');

  if (!slider) {
    return;
  }

  var track = slider.querySelector('[data-announcement-track]');
  var messages = track ? Array.prototype.slice.call(track.querySelectorAll('[data-announcement-message]')) : [];

  if (!track || messages.length < 2) {
    return;
  }

  var currentIndex = 0;
  var transitionDuration = 500;
  var intervalDuration = 3000;
  var firstMessage = messages[0].cloneNode(true);
  var slideCount = messages.length + 1;

  firstMessage.setAttribute('aria-hidden', 'true');
  track.appendChild(firstMessage);
  track.style.width = (slideCount * 100) + '%';
  Array.prototype.slice.call(track.querySelectorAll('[data-announcement-message]')).forEach(function (message) {
    message.style.flexBasis = (100 / slideCount) + '%';
  });

  function moveTo(index, animate) {
    track.style.transition = animate ? 'transform ' + transitionDuration + 'ms ease-in-out' : 'none';
    track.style.transform = 'translate3d(-' + (index * 100 / slideCount) + '%, 0, 0)';
  }

  function advance() {
    currentIndex += 1;
    moveTo(currentIndex, true);

    if (currentIndex === messages.length) {
      window.setTimeout(function () {
        currentIndex = 0;
        moveTo(currentIndex, false);
      }, transitionDuration);
    }
  }

  moveTo(0, false);
  window.setInterval(advance, intervalDuration);
}());
